export default "__VITE_ASSET__NZ5KpRkE__"